export enum RulesetSortField {
  NAME = 'name',
  UPDATED_AT = 'updatedAt',
  CREATED_BY = 'user.name'
}
